import { ReactElement, memo, useMemo } from "react";
import { useTranslation } from "react-i18next";

import PopupDialog from "../../../components/elements/PopupDialog/PopupDialog";
import "./ClearAllCartModal.scss";
import "./ClearAllCartModal_flint.scss";
import "./ClearAllCartModal_kokoro.scss";
import "./ClearAllCartModal_pdd.scss";
import "./ClearAllCartModal_shabuDays.scss";
import "./ClearAllCartModal_torikizoku.scss";
import "./ClearAllCartModal_wang.scss";

export interface IClearAllCartModalProps {
	onClose: () => void;
	open: boolean;
	onCancel: () => void;
	onConfirm: () => void;
}

const ClearAllCartModal = (props: IClearAllCartModalProps): ReactElement => {
	const { t } = useTranslation();
	const buttons = useMemo(
		() => [
			{
				text: t("cartPage.clearAllModal.button.cancel"),
				onClick: props.onCancel,
				className: "BtnClearAllCartCancel",
			},
			{
				text: t("cartPage.clearAllModal.button.confirm"),
				onClick: props.onConfirm,
				className: "BtnClearAllCartConfirm",
			},
		],
		[t, props.onCancel, props.onConfirm]
	);

	return (
		<PopupDialog
			onClose={props.onClose}
			open={props.open}
			content={<p className="PopupDialogContent">{t("cartPage.clearAllModal.info")}</p>}
			buttons={buttons}
			data-testid="ClearAllCartModal"
			className="ClearAllCartModal"
		/>
	);
};

export default memo(ClearAllCartModal);
